import * as Yup from 'yup';

const popupFormValidationSchema = Yup.object().shape({
  langCd: Yup.string().required('언어를 선택해주세요.'),
  popupEnvCd: Yup.string().required('노출환경을 선택해주세요.'),
  inactiveTime: Yup.number()
    .typeError('숫자를 입력해주세요.')
    .min(1, '비활성화 시간은 1시간 이상이어야 합니다.')
    .required('비활성화 시간을 입력해주세요.'),
  topPosition: Yup.number().typeError('숫자를 입력해주세요.').required('상단위치를 입력해주세요.'),
  leftPosition: Yup.number().typeError('숫자를 입력해주세요.').required('좌측위치를 입력해주세요.'),
  width: Yup.number()
    .typeError('숫자를 입력해주세요.')
    .required('넓이를 입력해주세요.')
    .min(10, '넓이는 10px 이상이어야 합니다.'),
  height: Yup.number()
    .typeError('숫자를 입력해주세요.')
    .required('높이를 입력해주세요.')
    .min(10, '높이는 10px 이상이어야 합니다.'),
});

export default popupFormValidationSchema;
